import { Box, Portal, rem } from '@mantine/core';
import { ReactNode } from 'react';

import { configWidth } from 'shared/utils/theme.utils';

import classes from './SideMenuPortalBase.module.scss';

type SideMenuPortalBaseProps = {
  children: ReactNode;
  width?: number;
};

export function SideMenuPortalBase(props: SideMenuPortalBaseProps) {
  const { children, width } = props;

  return (
    <Portal target="#studio-settings-portal">
      <Box
        className={classes.sideMenu}
        style={{ '--side-menu-width': rem(width ?? configWidth) }}
        data-testid="widget-side-menu"
      >
        {children}
      </Box>
    </Portal>
  );
}
